import React from 'react';
import { Factory, Clock, Snowflake, Thermometer, FileCheck, TrendingDown } from 'lucide-react';

const uspItems = [
  {
    icon: <Factory className="w-10 h-10 text-primary-500 mb-4" />,
    title: 'Производство под ключ',
    description: 'Проектирование, сборка, пусконаладка — полный цикл работ от одного подрядчика.',
  },
  {
    icon: <Clock className="w-10 h-10 text-primary-500 mb-4" />,
    title: 'Срок поставки от 50 дней',
    description: 'Чётко соблюдаем график производства и доставки оборудования на ваш объект.',
  },
  {
    icon: <Snowflake className="w-10 h-10 text-primary-500 mb-4" />,
    title: 'Работа при -60°C',
    description: 'Наши подстанции идеально подходят для эксплуатации в условиях Крайнего Севера.',
  },
  {
    icon: <Thermometer className="w-10 h-10 text-primary-500 mb-4" />,
    title: 'Утеплённый корпус',
    description: 'Используем сэндвич-панели для корпуса, что значительно экономит затраты на отопление.',
  },
  {
    icon: <FileCheck className="w-10 h-10 text-primary-500 mb-4" />,
    title: 'Сертификация ГОСТ, ТР ТС',
    description: 'Вся продукция сертифицирована, что позволяет участвовать в крупных госконтрактах.',
  },
  {
    icon: <TrendingDown className="w-10 h-10 text-primary-500 mb-4" />,
    title: 'Цены ниже на 10–20%',
    description: 'Благодаря собственному производству мы предлагаем лучшие цены на рынке.',
  },
];

const KtpnUsp: React.FC = () => {
  return (
    <section className="py-12 md:py-16 bg-gray-50">
      <div className="container-custom">
        <div className="text-center mb-10">
          <h2 className="text-3xl md:text-4xl font-bold">
            Почему за КТПН обращаются к нам
          </h2>
          <p className="mt-4 text-lg text-gray-600">
            Ключевые преимущества, которые получают наши клиенты.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {uspItems.map((item, index) => (
            <div key={index} className="bg-white p-6 rounded-lg shadow-md text-center card-hover">
              {item.icon}
              <h3 className="text-xl font-semibold mb-2">{item.title}</h3>
              <p className="text-gray-600">{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default KtpnUsp; 